import React from 'react'
import { FaRegHeart } from "react-icons/fa6";
import './DigiHealthLandingFooter.css'

const DigiHealthLandingFooter = () => {
  return (
    <footer className="Digi-Health-Landing-Footer-section-bg">
      <div className="Digi-Health-Landing-Footer-section-container">
        <div className="Digi-Health-Landing-Footer-section-left">
          <span className="Digi-Health-Landing-Footer-section-logo">
            <span className="Digi-Health-Landing-Footer-section-logo-icon">
              <FaRegHeart />
            </span>
            <span>
              <span className="Digi-Health-Landing-Footer-section-logo-text-main">DigiHealth</span>
              <br />
              <span className="Digi-Health-Landing-Footer-section-logo-text-sub">India</span>
            </span>
          </span>
        </div>
        <div className="Digi-Health-Landing-Footer-section-right">
          <span className="Digi-Health-Landing-Footer-section-copyright">
            © 2024 DigiHealth India. Transforming healthcare through innovation.
          </span>
        </div>
      </div>
    </footer>
  )
}

export default DigiHealthLandingFooter
